export const getDateFormatByLocale = (cultureCode: string) => cultureCode === 'cs-CZ' ? 'dd.MM.yyyy' : 'MM/dd/yyyy';